/**
 * @author TomaszCzura ({}
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';

class ModalDialog extends Component {
  constructor(props) {
    super(props);

    this.onCloseClick = this.onCloseClick.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const $dialog = $(`#${this.props.dialogId}`);
    $dialog.on('show.bs.modal', function(e) {
      if (e.target.id === _this.props.dialogId) {
        if (_this.props.onDialogShown) _this.props.onDialogShown();
      }
    });

    $dialog.on('hide.bs.modal', function(e) {
      if (e.target.id === _this.props.dialogId) {
        if (_this.props.onDialogHide) _this.props.onDialogHide();
      }
    });
  }

  onCloseClick() {
    $(`#${this.props.dialogId}`).modal('hide');
    if (this.props.onCloseClick) this.props.onCloseClick();
  }

  render() {
    const disabled = this.props.saveDisabled === undefined ? false : this.props.saveDisabled;
    const showSave = this.props.showSave === undefined ? true : this.props.showSave;
    const saveText = this.props.saveText || i18next.t('links.save');
    const closeText = this.props.closeText || i18next.t('links.close');

    return (
      <div className="modal fade"
        id={this.props.dialogId}
        role="basic"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div className={`modal-dialog ${this.props.customClass}`} style={this.props.customStyle}>
          <div className="modal-content">
            <div className="modal-header">
              {this.props.showClose ?
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"/> :
                null
              }
              {this.props.showCopyToClipboardButton ?
                <button
                  style={{marginBottom: '10px'}}
                  type="button"
                  className={`btn ${this.props.saveColor}`}
                  onClick={() => navigator.clipboard.writeText(this.props.dataToCopy)}
                >
                  Copy JSON to Clipboard
                </button> :
                null
              }
              <h4 className="modal-title">{this.props.modalTitle}</h4>
            </div>
            <div className="modal-body">
              {this.props.children}
            </div>
            <div className="modal-footer">
              {this.props.showChangesAppliedPrompt ?
                <span style={{marginTop: '15px', marginRight: '15px', color: 'red'}}>
                  <span>{i18next.t('confirmation.changes_applied')}</span>
                  <span>&nbsp;</span>
                  <i className={'icon-check'}/>
                </span> :
                null
              }
              {this.props.showCustomButton ?
                <button
                  type="button"
                  style={{marginTop: '15px'}}
                  className={`btn red`}
                  onClick={this.props.customButtonSubmit}
                >
                  {this.props.customButtonText}
                </button> :
                null
              }
              <button
                type="button"
                style={{marginTop: '15px'}}
                className={`btn ${this.props.closeColor} btn-outline default-secondary-button`}
                onClick={this.onCloseClick}
              >
                {closeText}
              </button>
              {showSave ?
                <button
                  type="button"
                  style={{marginTop: '15px'}}
                  className={`btn ${this.props.saveColor} default-button`}
                  onClick={this.props.onSubmit}
                  disabled={disabled}>{saveText}
                </button> :
                null
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ModalDialog.propTypes = {
  dialogId: PropTypes.string,
  modalTitle: PropTypes.string,
  children: PropTypes.node,
  onDialogShown: PropTypes.func,
  onDialogHide: PropTypes.func,
  onSubmit: PropTypes.func,
  showSave: PropTypes.bool,
  saveDisabled: PropTypes.bool,
  customClass: PropTypes.string,
  saveColor: PropTypes.string,
  closeColor: PropTypes.string,
  saveText: PropTypes.string,
  closeText: PropTypes.string,
  onCloseClick: PropTypes.func,
  showClose: PropTypes.bool,
  showCustomButton: PropTypes.bool,
  customStyle: PropTypes.object,
  showCopyToClipboardButton: PropTypes.bool,
  dataToCopy: PropTypes.string,
  customButtonText: PropTypes.string,
  customButtonSubmit: PropTypes.func,
  showChangesAppliedPrompt: PropTypes.bool,
};

ModalDialog.defaultProps = {
  saveColor: 'green',
  closeColor: 'dark',
  showClose: true,
  showCustomButton: false,
  customButtonText: '',
  showCopyToClipboardButton: false,
  showChangesAppliedPrompt: false,
};

export default ModalDialog;
